import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalUsernameUpdateController(
  $scope,
  $uibModalInstance,
  accountsService,
  modalData,
  modalConstantsService,
  languageResource
) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.user = {};
  $scope.usernameUpdateSuccess = false;
  $scope.doesPasswordExist = modalData.doesPasswordExist;
  $scope.isFreeUsernameChangeAllowed = modalData.isFreeUsernameChangeAllowed;
  $scope.usernameErrorMessage = function(form) {
    if (form.$pristine && $scope.error) {
      return $scope.error;
    }
    return null;
  };

  $scope.getChangePriceText = function() {
    if ($scope.isFreeUsernameChangeAllowed) {
      return languageResource.get('Description.Dialog.ChangeUsernameForFree');
    }

    return languageResource.get('Description.Dialog.ChangeUsernamePageText', {
      robuxIcon: '<span class=icon-robux-16x16></span>',
      price: '1000'
    });
  };

  $scope.changeUsernameV2 = function() {
    accountsService.beginAccountChangeUsernameV2($scope.user).then(
      function(result) {
        $scope.usernameUpdateSuccess = true;
      },
      function(error) {
        let errorMsg = modalConstantsService.default.error.body;
        if (error && error.errors && error.errors[0] && error.errors[0].message) {
          errorMsg = error.errors[0].message;
        }
        $scope.error = errorMsg;
      }
    );
  };

  $scope.submit = function(form) {
    form.$setPristine();
    $scope.error = '';
    if (!$scope.doesPasswordExist) {
      $scope.user.password = 'placeholder';
    }

    $scope.changeUsernameV2();
  };

  $scope.dismiss = function() {
    if ($scope.usernameUpdateSuccess) {
      $uibModalInstance.close(true);
    } else {
      $uibModalInstance.dismiss();
    }
  };
}

accountSettingsModule.controller(
  'accountSettingsModalUsernameUpdateController',
  accountSettingsModalUsernameUpdateController
);

export default accountSettingsModalUsernameUpdateController;
